import { render, staticRenderFns } from "./VehicleManagement.vue?vue&type=template&id=22eb28b6&scoped=true&"
import script from "./VehicleManagement.vue?vue&type=script&lang=js&"
export * from "./VehicleManagement.vue?vue&type=script&lang=js&"
import style0 from "./VehicleManagement.vue?vue&type=style&index=0&id=22eb28b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb28b6",
  null
  
)

export default component.exports